import { OnDestroy, Injector, Injectable } from '@angular/core';
import { LoggerParamsTransformer } from '@content-platform/web-angular-shared-util-logging';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { getADUser, getIsLoggedIn } from './auth/auth.selectors';
@Injectable()
export class AuthLoggingTransformer extends LoggerParamsTransformer implements OnDestroy {
  private user: adal.User;
  private loggedIn: boolean;
  private subscriptions: Subscription[] = [];

  constructor(protected injector: Injector) {
    super(injector);
  }

  initialize() {
    const store = this.injector.get(Store);
    this.subscriptions.push(store.pipe(select(getADUser)).subscribe((user) => (this.user = user)));
    this.subscriptions.push(
      store.pipe(select(getIsLoggedIn)).subscribe((loggedIn) => (this.loggedIn = loggedIn))
    );
  }

  getParams() {
    return {
      loggedIn: this.loggedIn,
      userName: this.user && this.user.userName,
      name: this.user && this.user.profile && this.user.profile.name,
    };
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
